import styled from 'styled-components/native';

import { neutralDark, peacock } from '../../constants/color';
import Image from '../Image';

export const S = {
  Container: styled.View`
    width: 100%;
    padding: 40px 0;
    align-items: center;
  `,
  NoMoreItemsImage: styled(Image)`
    width: 60px;
    height: 60px;
  `,
  NoMoreItemsText: styled.Text<{ color?: string }>`
    font-size: 13px;
    line-height: 18px;
    color: ${({ color }) => color || neutralDark};
  `,
  ActionBtnText: styled.Text<{ color?: string }>`
    color: ${({ color }) => color || peacock};
    font-size: 13px;
    line-height: 18px;
  `,
  EmptyResultImage: styled(Image)`
    width: 70px;
    height: 70px;
  `,
  EmptyResultTitle: styled.Text`
    margin: 15px;
    margin-bottom: 10px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.warrior};
    font-size: 15px;
    line-height: 21px;
  `,
};
